export enum AppZIndexes {
    Min = 2147483642,
    Ibe = 2147483642,
    Max = 2147483647,
}
